import { Injectable } from '@angular/core';
import { UserResponseDTO } from '@app/modules/user/interfaces/user-response-dto.interface';
import { Token } from '@interfaces/core/token.interface';
import { LocalStorageHandler } from '@services/local-storage-handler.service';

import { authConfig } from '../config';
import { TokenExpiryChecker } from './token-expiry-checker.service';

const sections = authConfig.actions.userAuthentication.sections;

@Injectable()
export class TokenChecker {
  constructor(
    private readonly localStorageUserHandler: LocalStorageHandler<UserResponseDTO>,
    private readonly localStorageTokenHandler: LocalStorageHandler<Token>,
    private readonly tokenExpiryChecker: TokenExpiryChecker,
  ) {}

  public isTokenActive(): boolean {
    const tokens = this.getTokensFromStorage();
    const user = this.getUserFromStorage();
    if (!tokens || !user) {
      return false;
    }

    if (this.tokenExpiryChecker.run(tokens.expiresIn)) {
      return false;
    }

    return true;
  }

  private getTokensFromStorage(): Token {
    return this.localStorageTokenHandler.read(sections.authToken);
  }

  private getUserFromStorage(): UserResponseDTO {
    return this.localStorageUserHandler.read(sections.authUser);
  }
}
